import React, { useEffect } from "react";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";

export default function PageShell({ children, testid }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <main data-testid={testid} className="bg-cream-50 text-charcoal min-h-screen">
      <Header />
      {/* Top spacer for fixed header */}
      <div className="h-20" aria-hidden="true" />
      {children}
      <Footer />
    </main>
  );
}
